import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaginationState } from '../../models/pagination';
import { ESettingsTab, SettingsTopbarTab } from './models';

type SettingsState = {
  ui: {
    tabs: SettingsTopbarTab[];
    workspaceUsers: {
      pagination: PaginationState;
      searchText: string;
    };
    workspaceInvites: {
      pagination: PaginationState;
    };
  };
};

export const initialState: SettingsState = {
  ui: {
    tabs: [
      { id: ESettingsTab.WORKSPACE, current: true, order: 1 },
      { id: ESettingsTab.COMPANY_USERS, current: false, order: 2 },
      { id: ESettingsTab.COMPANY, current: false, order: 3 },
    ],
    workspaceUsers: {
      pagination: {
        pageNo: 0,
        pageSize: 0,
      },
      searchText: '',
    },
    workspaceInvites: {
      pagination: {
        pageNo: 0,
        pageSize: 0,
      },
    },
  },
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    reset: () => initialState,
    setSettingsTabs: (state, action: PayloadAction<SettingsTopbarTab[]>) => ({
      ...state,
      ui: {
        ...state.ui,
        tabs: action.payload,
      },
    }),
    setWorkspaceUsersPagination: (state, action: PayloadAction<PaginationState>) => ({
      ...state,
      ui: {
        ...state.ui,
        workspaceUsers: {
          ...state.ui.workspaceUsers,
          pagination: action.payload,
        },
      },
    }),
    setWorkspaceUsersSearchText: (state, action: PayloadAction<string>) => ({
      ...state,
      ui: {
        ...state.ui,
        workspaceUsers: {
          ...state.ui.workspaceUsers,
          searchText: action.payload,
        },
      },
    }),
    setWorkspaceInvitesPagination: (state, action: PayloadAction<PaginationState>) => ({
      ...state,
      ui: {
        ...state.ui,
        workspaceInvites: {
          ...state.ui.workspaceInvites,
          pagination: action.payload,
        },
      },
    }),
  },
});

export const { reset, setSettingsTabs, setWorkspaceUsersPagination, setWorkspaceUsersSearchText, setWorkspaceInvitesPagination } = settingsSlice.actions;

export default settingsSlice.reducer;
